"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccordionBlockContentProperty = exports.accordionBlockContentPropertyDefinition = void 0;
exports.accordionBlockContentPropertyDefinition = {
    view: { label: 'Content' },
    constraints: [
        {
            name: 'properties',
            argument: [
                'text',
                'list',
                'numbered-list',
                'image',
            ],
        },
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'minLength',
            argument: 1,
        },
    ],
    type: 'container',
    multiple: true,
    name: 'accordion-block-content',
};
const isAccordionBlockContentProperty = (prop) => {
    return prop.name === exports.accordionBlockContentPropertyDefinition.name;
};
exports.isAccordionBlockContentProperty = isAccordionBlockContentProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3JkaW9uLWJsb2NrLWNvbnRlbnQucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9hY2NvcmRpb24tYmxvY2stY29udGVudC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFlYSxRQUFBLHVDQUF1QyxHQUFHO0lBQ3JELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUU7SUFDMUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsWUFBWTtZQUNsQixRQUFRLEVBQUU7Z0JBQ1IsTUFBTTtnQkFDTixNQUFNO2dCQUNOLGVBQWU7Z0JBQ2YsT0FBTzthQUNSO1NBQ0Y7UUFDRDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxDQUFDO1NBQ1o7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLHlCQUF5QjtDQUNBLENBQUE7QUFvQjFCLE1BQU0sK0JBQStCLEdBQUcsQ0FBQyxJQUFrQixFQUF5QyxFQUFFO0lBQzNHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywrQ0FBdUMsQ0FBQyxJQUFJLENBQUE7QUFDbkUsQ0FBQyxDQUFBO0FBRlksUUFBQSwrQkFBK0IsbUNBRTNDIn0=